module.exports = __webpack_public_path__ + "img/unitsGroupsEmptyState.503d64f7.svg";